import { Link, useParams } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { EmptyState, ErrorState, Skeleton } from "../components/ui/Feedback";
import { useCollection } from "../features/collections/useCollections";
import { ProductsTable } from "../features/products/ProductsTable";
import { formatNumber } from "../lib/format";

export const CollectionPage = () => {
	const { collectionId } = useParams();
	const query = useCollection(collectionId);

	if (query.isPending) {
		return (
			<div className="space-y-4">
				<Skeleton className="h-8 w-64" />
				<Skeleton className="h-64 w-full" />
			</div>
		);
	}

	if (query.isError || !query.data) {
		return (
			<ErrorState
				title="Could not load collection"
				description={(query.error as Error | null)?.message}
				action={
					<Link to="/collections">
						<Button variant="outline" size="sm">
							Back to collections
						</Button>
					</Link>
				}
			/>
		);
	}

	const { collection, items, total } = query.data;

	return (
		<div className="space-y-6">
			<div className="space-y-2">
				<Link
					to="/collections"
					className="text-xs text-ink-muted underline-offset-4 hover:underline"
				>
					← Collections
				</Link>
				<div className="flex items-center gap-3">
					{collection.imageUrl ? (
						<img
							src={collection.imageUrl}
							alt=""
							className="h-11 w-11 shrink-0 rounded-md border border-line object-cover"
						/>
					) : null}
					<div>
						<h2 className="text-xl font-semibold tracking-tight text-ink">
							{collection.title ?? "Untitled"}
						</h2>
						<p className="text-sm text-ink-muted">
							{formatNumber(total)} product{total === 1 ? "" : "s"}
						</p>
					</div>
				</div>
			</div>

			{items.length === 0 ? (
				<EmptyState
					title="Nothing in this collection"
					description="Either it is empty in Shopify, or the products in it have not synced yet."
				/>
			) : (
				<div className="overflow-hidden rounded-md border border-line">
					<ProductsTable products={items} />
				</div>
			)}
		</div>
	);
};
